export function equalityValidationFactory(name1, name2, message) {
  return formData => {
    const value1 = formData[name1],
      value2 = formData[name2];
    if (!!value1 && !!value2 && value1 !== value2) {
      return message;
    }
  };
}

export const passwordConfirmationValidation = equalityValidationFactory(
  'password',
  'password_confirmation',
  'Passwords do not match'
);



// WEBPACK FOOTER //
// ./src/services/validationHelpers.js